import {
    VERIFY_SERIAL,
    VERIFY_SERIAL_SUCCESS,
    VERIFY_SERIAL_FAILED,
    REGISTER_VEHICLE,
    REGISTER_VEHICLE_SUCCESS,
    REGISTER_VEHICLE_FAILED,
    VERIFY_QR,
    VERIFY_QR_SUCCESS,
    VERIFY_QR_FAILED,
    CLEAR_SERIAL_ERROR,
    ACTIVATE_REGISTRATION,
    ACTIVATE_REGISTRATION_SUCCESS,
    ACTIVATE_REGISTRATION_FAILED
} from '../store/types';

const INITIAL_STATE = {
    serialVerified: false,
    serialData: null,
    registration: null,
    qrData: null,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
};

export const serialreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case VERIFY_SERIAL:
            return { ...state, loading: true, error: { flag: false, msg: null } };
        case VERIFY_SERIAL_SUCCESS:
            return { ...state, serialVerified: true, serialData: action.payload, loading: false };
        case VERIFY_SERIAL_FAILED:
            return { ...state, serialVerified: false, serialData: null, loading: false, error: { flag: true, msg: action.payload } };
        case REGISTER_VEHICLE:
            return { ...state, loading: true, error: { flag: false, msg: null } };
        case REGISTER_VEHICLE_SUCCESS:
            return { ...state, registration: action.payload, loading: false };
        case REGISTER_VEHICLE_FAILED:
            return { ...state, registration: null, loading: false, error: { flag: true, msg: action.payload } };
        case VERIFY_QR:
            return { ...state, loading: true, error: { flag: false, msg: null } };
        case VERIFY_QR_SUCCESS:
            return { ...state, qrData: action.payload, loading: false };
        case VERIFY_QR_FAILED:
            return { ...state, qrData: null, loading: false, error: { flag: true, msg: action.payload } };
        case CLEAR_SERIAL_ERROR:
            return { ...state, error: { flag: false, msg: null } };
        case ACTIVATE_REGISTRATION:
            return { ...state, loading: true, error: { flag: false, msg: null } };
        case ACTIVATE_REGISTRATION_SUCCESS:
            return { ...state, registration: state.registration ? { ...state.registration, activated: true } : null, loading: false };
        case ACTIVATE_REGISTRATION_FAILED:
            return { ...state, loading: false, error: { flag: true, msg: action.payload } };
        default:
            return state;
    }
};
